import { RouteRecordRaw } from 'vue-router';
import LoginView from '~views/LoginView.vue';
import PageNotFound from '~views/PageNotFound.vue';
import DashboardView from '~views/DashboardView.vue';
import ScannerView from '~views/Scanner.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: PageNotFound,
  },
  {
    path: '/',
    redirect: '/login',
    name: 'home',
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/dashboard',
    name: 'DashboardView',
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: '/scanner',
    name: 'ScannerView',
    component: ScannerView,
    meta: { requiresAuth: true },
  },
];

export default routes;
